import React from 'react'
import {Helmet} from 'react-helmet';
// import BeProjects from './Components/BeProjects';
// import ProjectHead from '../../Components/Head/Projecthead';
import BeHead from '../../../Components/Head/BeHead';
import BeProjects from './BeProjects';
// import BeHead from '../../Components/Head/BeHead';


function BeProjectGrid() {
  return (
    <>
        <Helmet>
          <title>Yash Admin Sales Management System</title>                                                                                                                                                                                                                                 
        </Helmet>
        <div>
            {/* <ProjectHead /> */}
            {/* <BeHead /> */}
            <BeHead />
            <BeProjects />
        </div>
    </>
  )
}

export default BeProjectGrid;